import { kenectConfig } from './config';

const buildScriptEl = () => {
  const script = document.createElement('script');

  const attributes = {
    async: '',
    type: 'text/javascript',
    'data-publicId': kenectConfig.id,
    src: kenectConfig.src,
  };

  Object.entries(attributes).forEach(([attribute, value]) => {
    script.setAttribute(attribute, value);
  });

  return script;
};

const isKenectErrorEl = (element) => {
  const classesString = element.classList.toString().toLowerCase();

  return classesString.includes('error');
};

export default {
  buildScriptEl,
  isKenectErrorEl,
};
